import React, { useState } from "react"
import { Link } from "react-router-dom"

import Pagination from '@mui/material/Pagination'
import NumberFormat from "react-number-format"
import moment from "moment"
import { Tooltip } from '@mui/material'

import '../../assets/style/tablesG.css'
// import { LinearProgressBudget } from "./LinearProgressBudget"

export const TableList = ({ dataList = [], filters, setFilters, initGetAllBuyBudgets }) => {

    const [page, setPage] = useState(1)

    const handleChange = (event, value) => {
        setPage(value);
        const newFilters = {
            ...filters,
            page: value
        }

        setFilters(newFilters)
        initGetAllBuyBudgets(newFilters)
    }

    return (
        <div className='p-table'>

            <div className="row">
                <div className="col d-flex justify-content-start">
                    <span className="m-1" style={{ color: 'gray' }}>Montos con impuesto incluido</span>
                </div>
                <div className="col d-flex justify-content-end">
                    <Pagination
                        count={10}
                        page={page}
                        size="small"
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className="table-responsive">
                <table className="table p-table-global">
                    <thead className='p-thead-global'>
                        <tr className="text-center p-tr-titles-global">
                            <th>Número</th>
                            <th>Tiempo</th>
                            <th>Fecha presupuesto</th>
                            <th className="text-start">Referencia</th>
                            <th className="text-end">Total presupuesto</th>
                            <th className="text-end">Gasto actual</th>
                            <th className="text-end">Por gastar</th>
                            <th className="text-end">Pagado</th>
                            <th className="text-end">Por pagar</th>
                            {/* <th style={{ width: '150px' }}></th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {dataList?.map(item => (
                            <tr className='p-tr-body-global' key={item.id}>
                                <td className="text-center" >
                                    <Link className='LinkTable' to={`/gastos/pptos/${item.id}`}>
                                        {item.numero}
                                    </Link>
                                </td>
                                <td className="text-center" >
                                    <Link className='LinkTable' to={`/gastos/pptos/${item.id}`}>
                                        {item?.temporalidad || 'mensual'}
                                    </Link>
                                </td>
                                <td className="text-center">
                                    <Tooltip title={moment(item.fecha_asignacion_ini).format('DD-MM-YYYY')}>
                                        <Link className='LinkTable' to={`/gastos/pptos/${item.id}`} >
                                            {item.fecha_asignacion_ini ? moment(item.fecha_asignacion_ini).format('MMM YYYY') : '--'}
                                            {item.temporalidad !== 'mensual' ?
                                                <span>
                                                    {' - '}
                                                    {item.fecha_asignacion_fin ? moment(item.fecha_asignacion_fin).format('MMM YYYY') : '--'}
                                                </span> : ''
                                            }

                                        </Link>
                                    </Tooltip>
                                </td>
                                <td>
                                    <Link className='LinkTable' to={`/gastos/pptos/${item.id}`} >
                                        <p>{item.referencia}</p>
                                    </Link>
                                </td>
                                <td className='text-end'>
                                    <Link className='LinkTable' to={`/gastos/pptos/${item.id}`} >
                                        <NumberFormat
                                            value={item.total_ppto_final ? parseFloat(item.total_ppto_final).toFixed(0) : 0}
                                            displayType={'text'}
                                            thousandSeparator={item.separacion_miles}
                                            decimalSeparator={item.separacion_decimales}
                                            prefix={`${item.simbolo} `}
                                        />
                                    </Link>
                                </td>
                                <td className='text-end'>
                                    <Link className='LinkTable' to={`/gastos/pptos/${item.id}`} >
                                        {/* <NumberFormat
                                            value={item.total_gasto_real ? parseFloat(item.total_gasto_real).toFixed(0) : 0}
                                            displayType={'text'}
                                            thousandSeparator={item.separacion_miles}
                                            decimalSeparator={item.separacion_decimales}
                                            prefix={`${item.simbolo} `}
                                        /> */}
                                        <NumberFormat
                                            value={item.total_gasto_final ? parseFloat(item.total_gasto_final).toFixed(0) : 0}
                                            displayType={'text'}
                                            thousandSeparator={item.separacion_miles}
                                            decimalSeparator={item.separacion_decimales}
                                            prefix={`${item.simbolo} `}
                                        />
                                    </Link>
                                </td>
                                <td className='text-end'>
                                    <Link className='LinkTable' to={`/gastos/pptos/${item.id}`} >
                                        <NumberFormat
                                            value={item.total_por_gastar_final ? parseFloat(item.total_por_gastar_final).toFixed(0) : 0}
                                            displayType={'text'}
                                            thousandSeparator={item.separacion_miles}
                                            decimalSeparator={item.separacion_decimales}
                                            prefix={`${item.simbolo} `}
                                            style={{ color: parseFloat(item.total_por_gastar_final) < 0 ? 'red' : '' }}
                                        />
                                    </Link>
                                </td>
                                <td className='text-end'>
                                    <Link className='LinkTable' to={`/gastos/pptos/${item.id}`} >
                                        <NumberFormat
                                            value={item.total_pagado ? parseFloat(item.total_pagado).toFixed(0) : 0}
                                            displayType={'text'}
                                            thousandSeparator={item.separacion_miles}
                                            decimalSeparator={item.separacion_decimales}
                                            prefix={`${item.simbolo} `}
                                        />
                                    </Link>
                                </td>
                                <td className='text-end pe-3'>
                                    <Link className='LinkTable' to={`/gastos/pptos/${item.id}`} >
                                        <NumberFormat
                                            value={item.total_por_pagar ? parseFloat(item.total_por_pagar).toFixed(0) : 0}
                                            displayType={'text'}
                                            thousandSeparator={item.separacion_miles}
                                            decimalSeparator={item.separacion_decimales}
                                            prefix={`${item.simbolo} `}
                                        />
                                    </Link>
                                </td>
                                {/* <td>
                                    <Link className='LinkTable' to={`/gastos/pptos/${item.id}`} >
                                        <LinearProgressBudget
                                            balance={item.porcentaje_por_gastar_final ? parseFloat(item.porcentaje_por_gastar_final).toFixed(0) : 0}
                                        />
                                    </Link>
                                </td> */}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}